import styled from "@emotion/styled";
import { Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Box } from "@mui/system";
import myThemes from "../../common/themes/Themes";

export const StyledCaseDetailsBody = styled("div")(() => ({
  height: "400px",
  marginTop: "20px",
}));

export const TreatmentPlanContainer = styled(Box)(() => ({
  backgroundColor: "white",
  padding: "2rem",
}));

export const SectionTitle = styled(Typography)(() => ({
  fontSize: "1.125rem",
  fontWeight: "500",
  marginBottom: 1,
}));

export const DialogHeader = styled(Typography)(() => ({
  fontSize: "1.5rem",
  fontWeight: "600",
  marginBottom: 1,
}));

export const Note = styled(Box)(() => ({
  paddingLeft: "1rem",
  paddingRight: "2rem",
  paddingTop: "1rem",
  paddingBottom: "4rem",
  border: `1px solid ${grey[300]}`,
  borderRadius: "8px",
}));

export const FilesStack = styled(Stack)(() => ({
  padding: "1rem 0",
  width: "100%",
  overflowX: "auto",
}));

export const FileDetails = styled(Box)(() => ({
  width: "160px",
  height: "160px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: 2,
  backgroundColor: grey[100],
  borderRadius: "10px",
  boxSizing: "border-box",
  flexShrink: 0,
}));
